module.exports = __webpack_public_path__ + "static/media/deletered.e8a64d33.svg";